<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-dialog v-model="dialogLocal" scrollable max-width="870px">
        <v-card>
            <v-card-title>
                <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Test Protocol Selection</span>
            </v-card-title>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="closeDialog(null)">Cancel</v-btn>
            </v-card-actions>
            <v-card-text>
                <v-row>
                    <v-col xs=12>
                        <v-card tile flat class="blue lighten-1 pa-1" :height="598">
                            <v-card tile flat :height="590">
                                <v-card tile flat>
                                    <v-data-table
                                        :headers="headers"
                                        :items="testProtocolSuite.testProtocols"
                                        item-key="id"
                                        @click:row="rowSelected"
                                        :hide-default-footer="true"
                                        style="max-height: 590px; overflow-y: auto">
                                    </v-data-table>
                                </v-card>
                            </v-card>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'test-protocol-list-dialog',
        data: function()
        {
            return {
                dialogLocal: false,
                headers:
                [
                    {
                        text: 'Tag',
                        value: 'tag',
                        sortable: false
                    },
                    {
                        text: 'Lighting Mode',
                        value: 'lightingModeDisplay',
                        sortable: false
                    },
                    {
                        text: 'Recording Duration',
                        value: 'videoDurationDisplay',
                        sortable: false
                    },
                    {
                        text: 'Pulse Duration',
                        value: 'torchDurationDisplay',
                        sortable: false
                    },
                    {
                        text: 'Pulse Level',
                        value: 'torchLevelDisplay',
                        sortable: false
                    },
                    {
                        text: 'Ambient Level',
                        value: 'ambientLevelDisplay',
                        sortable: false
                    },
                    {
                        text: 'Illumination Delay',
                        value: 'illuminationDelayDisplay',
                        sortable: false
                    },
                    {
                        text: '2nd Eye Delay',
                        value: 'pauseSeconds',
                        sortable: false
                    },
                    {
                        text: 'No Baselines',
                        value: 'noBaseline',
                        sortable: false
                    },
                    {
                        text: 'Calculation Method',
                        value: 'calculationMethod',
                        sortable: false
                    }
                ],
                selectedProtocolSuite: null
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser,
                testProtocolSuite: state => state.testProtocolSuite
            }),
        },
        props:
        {
            dialog: Boolean(false)
        },
        watch:
        {
            async dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.$emit('dialog-close', this.selectedProtocolSuite)
                }
                else // Else the dialog is being opened
                {
                    this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                    {
                        app_name: 'Web Portal',
                        screen_name: `Reflex Web Portal - ${this.$options.name}`,
                        app_version: process.env.VUE_APP_VERSION
                    });
                    this.dialogLocal = val;
                    await this.loadItems()
                }
            },
            dialog(val)
            {
                this.dialogLocal = val
            }
        },
        methods:
        {
            ...mapActions('auth', ['GET_TEST_PROTOCOL_SUITE']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_WARN_DELAY', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            rowSelected(item)
            {
                this.closeDialog(item)
            },
            async loadItems()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_TEST_PROTOCOL_SUITE()
                }
                catch (error)
                {
                    // If the patient record associated with the test request was not found
                    if (404 === error.response.status)
                    {
                        this.SHOW_SNACKBAR_WARN_DELAY({message: 'You do not have a test protocol suite associated with your ID. Please contact the Reflex support team for assistance.', delay: 10000})
                    }
                    else
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message)
                    }
                }
                this.WAITING(false)
            },
            closeDialog(selectedProtocolSuite)
            {
                this.HIDE_SNACKBAR();
                this.selectedProtocolSuite = selectedProtocolSuite;
                this.HIDE_SNACKBAR();
                this.dialogLocal = false
            }
        }
    };
</script>

<style scoped>
</style>